// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {find, filter, get, isEmpty, isEqual, pick} from 'lodash';

// Components
import Button from '../core/button';

// Containers
import Mapping from '../../containers/mapping';

// Styles
import './flag-metadata-buttons.scss';

function FlagMetadataButtons({
  flaggedMetadata: { flaggedMetadataCompleteFlagging, flaggedMetadataIssues, flaggedMetadataReset },
  searchData: [amsProgram = {}] = [],
}) {
  const shouldDisableCompleteButton = () => {
    const originalIssues = get(amsProgram, 'flaggedMetadata.issues', []);

    return (
      originalIssues.length === flaggedMetadataIssues.length
            && isEmpty(
              filter(flaggedMetadataIssues, ({ comment = null, fieldName, issueType }) => isEmpty(
                  find(originalIssues, (originalIssue) => isEqual(pick(originalIssue, ['comment', 'fieldName', 'issueType']), {
                                comment,
                    fieldName,
                    issueType,
                  }),
                        )
                    ),
                ),
            )
    );
  };

  const shouldRenderButton = (type, mapping) => {
    const conditional = {
      cancelFlagMetadata: () => true,
      completeFlagging: () => true,
      completeFlaggingAndMap: () => true,
      completeFlaggingAndCreateShell: () => (!!get(amsProgram, 'roviProgramId') || !!get(amsProgram, 'tmsId') || !!get(amsProgram, 'sourceId'))
                && ((mapping.mappingData && mapping.mappingData.franchise) || amsProgram.echostarContentType !== 'SRE'),
    };

    return conditional[type] ? conditional[type]() : false;
  };

  const renderButton = (type) => {
    const renderButtonProps = {
      cancelFlagMetadata: {
        children: 'Exit Flagging',
        onClick: flaggedMetadataReset,
      },
      completeFlagging: {
        children: 'Complete Flagging And Exit',
        disabled: shouldDisableCompleteButton(),
        onClick: () => flaggedMetadataCompleteFlagging(),
      },
      completeFlaggingAndMap: {
        children: 'Complete Flagging And Map',
        disabled: shouldDisableCompleteButton(),
        onClick: () => flaggedMetadataCompleteFlagging('map'),
      },
      completeFlaggingAndCreateShell: {
        children: 'Complete Flagging And Create Shell',
        disabled: shouldDisableCompleteButton(),
        onClick: () => flaggedMetadataCompleteFlagging('createShell'),
      },
    };

    return (
            <Mapping>
                {(mapping) => (shouldRenderButton(type, mapping) ? (
                        <Button {...renderButtonProps[type]} className="flag-metadata-buttons--button" />
                    ) : null)}
            </Mapping>
    );
  };

  return (
        <div className="flag-metadata-buttons--actions">
            {renderButton('completeFlagging')}
            {renderButton('completeFlaggingAndMap')}
            {renderButton('completeFlaggingAndCreateShell')}
            {renderButton('cancelFlagMetadata')}
        </div>
  );
}

FlagMetadataButtons.propTypes = {
    flaggedMetadata: PropTypes.object,
    searchData: PropTypes.array,
};

export default FlagMetadataButtons;
